import React from "react";
import PropTypes from "prop-types";
import ProteinRegion from "../../../../../models/ProteinRegion";
import getBaseLen from "../../../helpers/getBaseLen";

function ProteinTitle(props) {
  const { item, actions } = props;

  if (!item) return null;

  return (
    <div className="tw-max-w-96">
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">{item.protein}</div>
        {actions}
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-20 tw-flex-shrink-0">Type</div>
        <div>{item.type}</div>
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-20 tw-flex-shrink-0">Amino Acid</div>
        <div>{item.aminoAcid}</div>
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-20 tw-flex-shrink-0">Position</div>
        <div className="tw-flex-grow">
          {item.region.chromosome.name}:{item.region.x0.toLocaleString()}
        </div>
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-20 tw-flex-shrink-0">Length</div>
        <div className="tw-flex-grow">{getBaseLen(item.region.size)}</div>
      </div>

      {item.description ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-20 tw-flex-shrink-0">
            Description
          </div>
          <div>{item.description}</div>
        </div>
      ) : null}
    </div>
  );
}

ProteinTitle.propTypes = {
  item: PropTypes.instanceOf(ProteinRegion).isRequired,
  actions: PropTypes.node,
};

ProteinTitle.defaultProps = {
  actions: null,
};

export default ProteinTitle;
